export default __webpack_public_path__ + "static/media/edit.8a0406f3.png";